var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
import { CustomTypedEvent } from '../../events';
//namespace Pacem.Components {
export const ScrollEventName = 'scroll';
export class ScrollEvent extends CustomTypedEvent {
    constructor(args) {
        super(ScrollEventName, args);
    }
}
// see also viewport-aware
class PacemScrollOrchestrator {
    constructor(global) {
        this.global = global;
        this.scrollers = [];
        this.scrollHandler = (evt) => {
            this._scroll(evt);
        };
    }
    register(vport) {
        const scrlls = this.scrollers;
        if (scrlls.indexOf(vport) === -1) {
            scrlls.push(vport);
            if (scrlls.length === 1) {
                this.global.addEventListener('scroll', this.scrollHandler, false);
            }
            this._scroll();
        }
    }
    unregister(vport) {
        var ndx;
        const scrlls = this.scrollers;
        if ((ndx = scrlls.indexOf(vport)) !== -1) {
            scrlls.splice(ndx, 1);
            if (scrlls.length === 0) {
                this.global.removeEventListener('scroll', this.scrollHandler, false);
            }
        }
    }
    _scroll(_) {
        for (var scroller of this.scrollers) {
            if (Utils.isNull(scroller.target)) {
                const top = Utils.scrollTop, left = Utils.scrollLeft;
                scroller.offset = { top, left };
            }
            else {
                const top = scroller.target.scrollTop, left = scroller.target.scrollLeft;
                scroller.offset = { top, left };
            }
            scroller.dispatchEvent(new ScrollEvent(scroller.offset));
        }
    }
}
const ORCHESTRATOR = new PacemScrollOrchestrator(window);
/**
 * Manages scrolling interactions firing self-referenced ad-hoc events.
 */
let PacemScrollAwareElement = class PacemScrollAwareElement extends PacemEventTarget {
    viewActivatedCallback() {
        super.viewActivatedCallback();
        //
        ORCHESTRATOR.register(this);
    }
    disconnectedCallback() {
        ORCHESTRATOR.unregister(this);
        //
        super.disconnectedCallback();
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Element })
], PacemScrollAwareElement.prototype, "target", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemScrollAwareElement.prototype, "offset", void 0);
PacemScrollAwareElement = __decorate([
    CustomElement({
        tagName: P + '-scroll-aware'
    })
], PacemScrollAwareElement);
export { PacemScrollAwareElement };
//}
